import { TableCell, TableRow, Checkbox, toCurrencyString, CurrencyCode } from '@client/toolkit';
import { TableExpandableCell } from '../../components/table-expanable-cell';
import { useTranslation } from 'react-i18next';
import { ChangePercentage } from '../../components';
import { VacancyDetailsDto } from '@client/api';

export const BuildingRow = ({
  building,
  selectedRows,
  handleToggleSelect,
  handleKeyDownSelect,
  handleToggleExpand,
  handleKeyDownExpand,
  expandedRows,
}: {
  building: VacancyDetailsDto;
  selectedRows: Set<string>;
  handleToggleSelect: (id: string) => void;
  handleKeyDownSelect: (e: React.KeyboardEvent<Element>, id: string) => void;
  handleToggleExpand: (id: string) => void;
  handleKeyDownExpand: (e: React.KeyboardEvent<Element>, id: string) => void;
  expandedRows: Set<string>;
}) => {
  const { t } = useTranslation('reporting');
  return (
    <TableRow className="bg-surface-elevated/40 border-b border-surface-elevated group hover:bg-surface-elevated">
      <TableCell className="px-2 py-2 align-top content-center">
        <Checkbox
          checked={selectedRows.has(building.buildingId)}
          onChange={() => handleToggleSelect(building.buildingId)}
          tabIndex={0}
          aria-label={`${t('table.select')} ${building.buildingName}`}
          onKeyDown={(e) => handleKeyDownSelect(e, building.buildingId)}
        />
      </TableCell>
      <TableExpandableCell
        label={building.buildingName}
        onClick={() => handleToggleExpand(building.buildingId)}
        onKeyDown={(e) => handleKeyDownExpand(e, building.buildingId)}
        ariaLabel={
          expandedRows.has(building.buildingId)
            ? `${t('table.selectedEntity')} ${building.buildingName}`
            : `${t('table.expandedEntity')} ${building.buildingName}`
        }
        isExpanded={expandedRows.has(building.buildingId)}
      />
      <TableCell className="px-2 py-2 align-top">
        {t('vacancyCost.premisesCount', { count: building.numberOfPremises })}
      </TableCell>
      <TableCell className="px-2 py-2 align-top">{building.vacantSqmDays}</TableCell>
      <TableCell className="px-2 py-2 align-top">
        {!building.selectedYearAmount
          ? t('notAvailable')
          : toCurrencyString(building.selectedYearAmount.value, '-', {
              currency: building.selectedYearAmount.currency as CurrencyCode,
            })}
      </TableCell>
      <TableCell className="px-2 py-2 align-top">
        {!building.previousYearAmount
          ? t('notAvailable')
          : toCurrencyString(building.previousYearAmount.value, '-', {
              currency: building.previousYearAmount.currency as CurrencyCode,
            })}
      </TableCell>
      <TableCell className="px-2 py-2 align-top">
        {building.numberOfWeekAvailable === 0 ? `0 ${t('vacancyCost.weeks')}` : ''}
        {building.numberOfWeekAvailable / 4 >= 1
          ? `${Math.floor(building.numberOfWeekAvailable / 4)} ${t('vacancyCost.month')}`
          : ''}
        {building.numberOfWeekAvailable % 4 >= 1
          ? ` ${Math.floor(building.numberOfWeekAvailable % 4)} ${t('vacancyCost.weeks')}`
          : ''}
      </TableCell>
      <TableCell className="px-2 py-2 align-top">
        <ChangePercentage value={building.changePercentage} size="sm" isInverted />
      </TableCell>
    </TableRow>
  );
};
